import { createGlobalStyle } from 'styled-components';
import 'font-awesome/css/font-awesome.min.css';
import 'react-circular-progressbar/dist/styles.css';
import './docs/css/themify-icons.scss'
import './docs/css/Pe-icon-7-filled.scss'
import './docs/css/icofont.scss'
import './docs/css/mixin.scss';
import './docs/css/style.scss';
const GlobalStyle = createGlobalStyle`
    .p-30{
        padding: 30px;
    }
`;

export default GlobalStyle;
